import { COLOR } from 'vars/color'
import { Icon } from '../Icon'
import { IconNames, IconQualitySizes, IconSizes } from '../Icon.h'

export interface IDolbyAtmosLabelIconProps {
  color?: string
  size?: IconQualitySizes
  height?: IconSizes
}

export const DolbyAtmosLabelIcon = ({
  color = COLOR.TEXT_ICON_SECONDARY,
  size = IconQualitySizes.dolbyAtmos,
  height = IconSizes.xMSm,
}: IDolbyAtmosLabelIconProps) => {
  return (
    <Icon
      name={IconNames.dolbyAtmos}
      color={color}
      size={size}
      height={height}
    />
  )
}
